import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20security%20and%20protection%20concept%20with%20warm%20beige%20and%20cream%20gradient%20background%2C%20subtle%20geometric%20shield%20pattern%2C%20soft%20diffused%20lighting%2C%20clean%20modern%20aesthetic%2C%20calm%20and%20trustworthy%20atmosphere%2C%20no%20text%2C%20abstract%20digital%20safety%20visualization&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block text-xs md:text-sm font-medium text-white/80 bg-white/15 backdrop-blur-sm px-4 py-1.5 rounded-full mb-6 tracking-wide">
            理性 · 安全 · 负责任
          </span>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 md:mb-6 leading-tight font-heading">
            成人网站完整指南
          </h1>
          <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed mb-8">
            提供安全访问建议、隐私保护方法、内容分级筛选及合规使用须知，帮助成年用户理性、安全地了解相关平台信息，避免风险与法律问题。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/safe-access"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-6 py-3 rounded-md font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shield-check-line"></i>
              开始了解安全访问
            </Link>
            <Link
              to="/category/privacy-protection"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white border border-white/25 px-6 py-3 rounded-md font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-eye-off-line"></i>
              隐私保护指南
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}